import { Outlet } from "react-router";

export const PageLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
